import "../assets/Spinner.css";
import { jsx as t, jsxs as o } from "preact/jsx-runtime";
import { c as a } from "./index.2w0W-O47.js";
const c = "_spinner_gcwmn_1", l = "_l_gcwmn_7", m = "_blue_gcwmn_13", p = "_white_gcwmn_17", r = {
  spinner: c,
  l,
  blue: m,
  white: p
}, f = ({
  dimension: n = "s",
  color: s = "currentColor",
  ...e
}) => {
  const i = n === "s" ? d : w;
  return /* @__PURE__ */ t(
    "div",
    {
      ...e,
      class: a([r.spinner, r[s], r[n], e.class]),
      "data-testid": "spinner",
      children: /* @__PURE__ */ t(i, {})
    }
  );
}, d = () => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", children: /* @__PURE__ */ o("g", { stroke: "currentColor", "stroke-width": "2", "transform-origin": "50% 50%", children: [
  /* @__PURE__ */ t("path", { d: "M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16Z", opacity: ".1" }),
  /* @__PURE__ */ t("path", { "stroke-linecap": "round", d: "M9 17A8 8 0 1 0 4.912 2.122" }),
  /* @__PURE__ */ t(
    "animateTransform",
    {
      attributeName: "transform",
      dur: "1.2s",
      repeatCount: "indefinite",
      type: "rotate",
      from: "0 0 0",
      to: "360 0 0"
    }
  )
] }) }), w = () => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 54 54", children: /* @__PURE__ */ o("g", { stroke: "currentColor", "stroke-width": "4", "transform-origin": "50% 50%", children: [
  /* @__PURE__ */ t(
    "path",
    {
      d: "M27 52c13.807 0 25-11.193 25-25S40.807 2 27 2 2 13.193 2 27s11.193 25 25 25Z",
      opacity: ".4"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      "stroke-linecap": "round",
      d: "M27 52c13.807 0 25-11.193 25-25S40.807 2 27 2c-4.668 0-9.037 1.28-12.776 3.507"
    }
  ),
  /* @__PURE__ */ t(
    "animateTransform",
    {
      attributeName: "transform",
      dur: "1.2s",
      repeatCount: "indefinite",
      type: "rotate",
      from: "0 0 0",
      to: "360 0 0"
    }
  )
] }) });
export {
  f as S
};
